import React from "react";
import logoWhite from '../../assets/logo-blanc.png';

import CONFIG from '../../config';

import axios from "axios";
import { Link } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';


function Footer() {
  return (
    <>
      <footer className="p-4 bg-ame-dark sm:p-6 bg-ame-gray mt-6">
        <div className="lg:flex lg:justify-between">
          <div className="mb-6 lg:mb-0 lg:mr-14"><a className="flex items-center" href="https://mouv-immo.com/" target="_blank"><span><img className="w-48" alt="" aria-hidden="true" src={logoWhite} /></span></a></div>
          <div className="grid grid-cols-2 gap-8 sm:gap-24 sm:grid-cols-4">
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-ame-orange">Contact</h2>
              <ul className="text-white">
                <li className="mb-4">agence@mouv-immo.com</li>
              </ul>
            </div>
            {/* <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-ame-orange">Nous rendre visite</h2>
              <ul className="text-white">
                <li className="mb-4">16 Rue Lieutenant-Colonel Prévost</li>
                <li className="mb-4">69006 Lyon</li>
              </ul>
            </div> */}
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-ame-orange">En savoir plus</h2>
              <ul className="text-white">
                <a className="underline cursor-pointer" href="https://www.actionlogement.fr/financement-mobilite" target="_blank">
                  <li className="mb-4">
                    <span className="underline cursor-pointer font-bold whitespace-nowrap text-white">
                      Mobili-Pass ®
                    </span>
                  </li>
                </a>
                <a className="underline cursor-pointer" href="https://mouv-immo.com/accueil" target="_blank">
                  <li className="mb-4">Qui sommes-nous ?</li>
                </a>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-ame-orange">Légal</h2>
              <ul className="text-white">
                <a className="underline cursor-pointer" href={CONFIG.BASE_URL + "/mentions"} target="_blank">
                  <li className="mb-4">Mentions légales</li>
                </a>
                <a className="underline cursor-pointer" href={CONFIG.BASE_URL + "/cgu"} target="_blank">
                  <li className="mb-4">CGU</li>
                </a>
                <a className="underline cursor-pointer" href={CONFIG.BASE_URL + "/politique"} target="_blank">
                  <li className="mb-4">Politique de données</li>
                </a>
              </ul>
            </div>
          </div>
        </div>
        <hr className="my-6 border-ame-orange sm:mx-auto lg:my-8" />
        <div className="sm:grid grid-cols-3 sm:items-center ">
          <span className="text-sm text-white sm:text-center mr-auto">© Copyright<a className="hover:underline ml-2" href="https://mouv-immo.com/" target="_blank">Mouv'Immo</a></span>
          <div className="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
            <a href="https://www.facebook.com/mouvimmo.lyon" target="_blank" rel="noreferrer" className="text-white hover:text-ame-orange ">
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd"></path>
              </svg>
            </a>
            <a href="https://www.instagram.com/mouv_immo/" rel="noreferrer" target="_blank" className="text-white hover:text-ame-orange ">
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fill-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clip-rule="evenodd"></path>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/mouvimmo/" target="_blank" rel="noreferrer" className="text-white hover:text-ame-orange ">
              <svg fill="currentColor" viewBox="0 0 64 64" className="w-8 h-8">
                <path d="M32,6C17.641,6,6,17.641,6,32c0,14.359,11.641,26,26,26s26-11.641,26-26C58,17.641,46.359,6,32,6z M25,44h-5V26h5V44z M22.485,24h-0.028C20.965,24,20,22.888,20,21.499C20,20.08,20.995,19,22.514,19c1.521,0,2.458,1.08,2.486,2.499 C25,22.887,24.035,24,22.485,24z M44,44h-5v-9c0-3-1.446-4-3-4c-1.445,0-3,1-3,4v9h-5V26h5v3c0.343-0.981,1.984-3,5-3c4,0,6,3,6,8 V44z"></path>
              </svg>
            </a>
          </div>
          <span className="text-sm text-white text-center justify-center sm:text-center ml-auto">
            <div className="flex items-center col-span-12 mt-1 max-h-fit w-full justify-center mx-auto">
            <a className="font-bold" href="https://yktis.com/?b842" target="_blank"><img src="https://yktis.com/img/logo.png" alt="Yktis logo" className="h-4 mr-2" /></a>
            </div>
            <div className="flex items-center col-span-12 mt-1 max-h-fit">
              <p className="text-white text-sm">Made with ❤️ by <a className="font-bold" href="https://yktis.com/?b842" target="_blank">Yktis</a></p>
            </div>
          </span>

          {/* <div className="items-end col-span-2 mt-4 grid grid-cols-12 justify-items-end">
            
          </div> */}
        </div>
      </footer>
    </>
  );
}

export default Footer;